export default "__VITE_ASSET__2b69821e__"